<template>
	<div v-if="hasErrors" class="server-error-box">
		<div v-if="blacklist">
			{{ $t('Error.Message.blacklist_text') }}
			<span class="server-error-box-item">{{ errors.join(', ') }}</span>
		</div>
		<div v-else>
			<div
				v-for="(value, key) in errors"
				:key="key"
				v-html="value[0] && value[0].includes(' ') ? value[0] : $t('Error.Message.' + value)"
			></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FormErrorsBox',
	props: {
		blacklist: {
			type: Boolean,
			default: false,
		},
		errors: {
			type: [Object, Array],
			required: true,
		},
	},
	computed: {
		decodeValue() {
			return this.value.includes(' ') ? this.value : this.$t('Error.Message.' + this.value)
		},
		hasErrors() {
			return this.errors instanceof Object ? Object.keys(this.errors).length : this.errors.length
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/FormErrorsBox.vue